import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "lucide-react";
import { MyRentalsPanel } from "@/components/parent/MyRentalsPanel";

export const Route = createFileRoute("/_authenticated/responsavel/minhas-reservas")({
  component: MyReservationsPage,
  head: () => ({
    meta: [
      { title: "Minhas Reservas | FutBux" },
      { name: "description", content: "Acompanhe suas reservas de espaço no centro de treinamento." },
      { property: "og:title", content: "Minhas Reservas | FutBux" },
      { property: "og:description", content: "Acompanhe suas reservas de espaço no centro de treinamento." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function MyReservationsPage() {
  return (
    <div className="p-4 max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold flex items-center gap-2">
        <Calendar className="w-6 h-6 text-primary" /> Minhas Reservas
      </h1>
      <MyRentalsPanel />
    </div>
  );
}
